// extracted by mini-css-extract-plugin
export default {"RestaurantDashboardContainer":"dashboard_restaurant_santander_page_RestaurantDashboardContainer__AVdAh","CardsContainer":"dashboard_restaurant_santander_page_CardsContainer__pB3eB"};